import React, { createContext, useState } from 'react';

export type LoadingContext = {
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

const defaultValue: LoadingContext = {
  isLoading: false,
  setIsLoading: () => {},
};

/**
 * ローディング状態を管理する
 */
export const LoadingContext = createContext(defaultValue);

export const LoadingMutationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <LoadingContext.Provider
      value={{
        isLoading,
        setIsLoading,
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};
